import { filterOwlbertCloudLlmCatalogForHostedWeb } from '@owlbert/core'

/** Rows returned by backend `llm.getModels` (subset used by the web UI). */
export type CloudLlmModelOption = {
  id: string
  provider: string
  model_id: string
  name: string
}

export type LlmCatalogClient = {
  llm: { getModels: { query: () => Promise<{ models: CloudLlmModelOption[] }> } }
}

/** Owlbert cloud catalog: active registry models for the signed-in user, excluding RunPod/custom endpoints. */
export async function fetchOwlbertCloudLlmModelOptions(client: LlmCatalogClient): Promise<CloudLlmModelOption[]> {
  const { models } = await client.llm.getModels.query()
  return filterOwlbertCloudLlmCatalogForHostedWeb(models as CloudLlmModelOption[])
}

export function resolveAssistantLlmSelectValue(stored: string | undefined, options: CloudLlmModelOption[]): string {
  if (options.length === 0) return (stored ?? '').trim()
  const ids = new Set(options.map((o) => o.id))
  const s = (stored ?? '').trim()
  if (s && ids.has(s)) return s
  if (s) {
    const byModelId = options.find((o) => o.model_id === s)
    if (byModelId) return byModelId.id
    const byCompound = options.find((o) => o.id === s || o.id.endsWith(`:${s}`))
    if (byCompound) return byCompound.id
  }
  const preferred =
    options.find((o) => o.id === 'openai:gpt-4o-mini') ??
    options.find((o) => o.provider !== 'auto') ??
    options[0]
  return preferred?.id ?? ''
}

export function cloudLlmModelsToSelectData(options: CloudLlmModelOption[]) {
  return options.map((m) => ({
    value: m.id,
    label: m.provider === 'auto' ? m.name : `${m.name} (${m.provider}:${m.model_id})`,
  }))
}
